import {
  DefectReportHistoryFilters,
  DefectRange,
} from 'business/quality-control/pages/defect-report-history/providers/filters';

export const formatFilterParams = (
  filters: DefectReportHistoryFilters,
  { hasIndicators }: { hasIndicators: boolean },
) => {
  return {
    defectType: filters.defectType,
    toRepair: filters.toRepair ?? null,
    // A hidden filter must not keep restricting the results
    indicator: hasIndicators ? (filters.indicator ?? null) : null,
    defectReportHistoryDate:
      filters.defectReportHistoryDate &&
      (filters.defectReportHistoryDateRange?.[0] ||
        filters.defectReportHistoryDateRange?.[1])
        ? filters.defectReportHistoryDate
        : null,
    defectReportDateStart:
      filters.defectReportHistoryDateRange?.[0]?.startOf('day').toISOString() ??
      null,
    defectReportDateEnd:
      filters.defectReportHistoryDateRange?.[1]?.endOf('day').toISOString() ??
      null,
    status: filters.status,
    defectRange: filters.defectRange,
    ringNumberStart:
      filters.defectRange === DefectRange.interval
        ? filters.ringNumberRange[0]
        : null,
    ringNumberEnd:
      filters.defectRange === DefectRange.interval
        ? filters.ringNumberRange[1]
        : null,
  };
};
